/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Live_Platform_BlurbInputs */

const en_live_platform_blurb = /** @type {(inputs: Live_Platform_BlurbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} data through one normalized API - per-request USD pricing and no subscriptions.`)
};

const zh_hans1_live_platform_blurb = /** @type {(inputs: Live_Platform_BlurbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`通过一个标准化 API 获取 ${i?.name} 数据：按请求以美元计价，无需订阅。`)
};

const pt_br2_live_platform_blurb = /** @type {(inputs: Live_Platform_BlurbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dados de ${i?.name} em uma única API normalizada: preço por requisição em dólares e sem assinatura.`)
};

const es_live_platform_blurb = /** @type {(inputs: Live_Platform_BlurbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Datos de ${i?.name} a través de una sola API normalizada, con precio por solicitud en USD y sin suscripciones.`)
};

const fr_live_platform_blurb = /** @type {(inputs: Live_Platform_BlurbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Les données ${i?.name} via une seule API normalisée - tarification en USD par requête et sans abonnement.`)
};

const de_live_platform_blurb = /** @type {(inputs: Live_Platform_BlurbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}-Daten über eine normalisierte API, mit Preis pro Anfrage in USD und ohne Abos.`)
};

const ru_live_platform_blurb = /** @type {(inputs: Live_Platform_BlurbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Данные ${i?.name} через один нормализованный API: цена за запрос в долларах США и никаких подписок.`)
};

const it_live_platform_blurb = /** @type {(inputs: Live_Platform_BlurbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I dati di ${i?.name} attraverso un'unica API normalizzata - prezzo a richiesta in USD e nessun abbonamento.`)
};

/**
* | output |
* | --- |
* | "{name} data through one normalized API - per-request USD pricing and no subscriptions." |
*
* @param {Live_Platform_BlurbInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const live_platform_blurb = /** @type {((inputs: Live_Platform_BlurbInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Platform_BlurbInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_live_platform_blurb(inputs)
	if (locale === "pt-BR") return pt_br2_live_platform_blurb(inputs)
	if (locale === "es") return es_live_platform_blurb(inputs)
	if (locale === "fr") return fr_live_platform_blurb(inputs)
	if (locale === "de") return de_live_platform_blurb(inputs)
	if (locale === "ru") return ru_live_platform_blurb(inputs)
	if (locale === "it") return it_live_platform_blurb(inputs)
	return en_live_platform_blurb(inputs)
});